import React, { useContext } from 'react'
import ReactDOM from 'react-dom'
import { flowRight } from 'lodash'
import { withTranslationCustom } from 'lib/i18next'
import { withRouter } from 'react-router-dom'
import { ExtendedFormikContext } from 'components/Forms/ExtendedFormik'
import queryString from 'query-string'
import {
    addLocationSearchParams,
    deleteLocationSearchParam,
    getFullPath,
} from 'lib/location'

import EventFormModule from 'components/Events/EventForm/EventFormModules/EventFormModule'
import CompactFormRow from 'components/Forms/CompactForm/CompactFormRow/CompactFormRow'
import MapsPlaceSelect from 'components/Maps/MapsPlaceSelect'
import Icon from 'components/Icon'

import './event-form-location-module.pcss'

const types = [
    'gas_station',
    'car_dealer',
    'car_rental',
    'car_repair',
    'car_wash',
    'parking',
    'rv_park',
]

const EventFormLocationModule = ({ t, history, location, match, label }) => {
    const { setFieldValue, values } = useContext(ExtendedFormikContext)

    const parsedSearch = queryString.parse(location.search)
    const open = parsedSearch['location-picker'] !== undefined

    const mapCenter = {
        lat: values.locationLatitude || 0,
        lng: values.locationLongitude || 0,
    }
    const placeId = values.locationGooglePlaceId || null
    const locationName = values.locationName || null
    const locationVicinity = values.locationVicinity || null

    const getDisplayName = () => {
        if (locationName) {
            return `${locationName} ${locationVicinity ? ', ' + locationVicinity : ''}`
        } else if ((mapCenter.lat || mapCenter.lng)) {
            return t('Sijainti kartalla')
        }

        return null
    }

    const displayName = getDisplayName()

    const handleOpen = () => {
        const newLocation = addLocationSearchParams(location, { 'location-picker': null })
        history.push(getFullPath(newLocation))
    }

    const handleClose = () => {
        const newLocation = deleteLocationSearchParam(location, 'location-picker')
        history.replace(getFullPath(newLocation))
    }

    return (
        <EventFormModule className="event-form-location-module">
            <CompactFormRow
                iconName="map-marker-alt"
                label={label}
                onClick={handleOpen}
                className="compact-form-date-row"
                trackName="location"
                expandable
                editIcon={displayName ? (
                    <Icon
                        fa
                        name="pen"
                        cssClass="icon--event-form"
                    />
                ) : null}
            >
                {!open && displayName}
            </CompactFormRow>
            {open && (
                <div>
                    {
                        ReactDOM.createPortal(
                            (
                                <MapsPlaceSelect
                                    types={types}
                                    initCenter={mapCenter}
                                    initPlaceId={placeId}
                                    onPlaceSelect={(point, place) => {
                                        setFieldValue('locationLatitude', point.lat)
                                        setFieldValue('locationLongitude', point.lng)
                                        setFieldValue('locationName', place && place.name ? place.name : '')
                                        setFieldValue('locationVicinity', place && place.vicinity ? place.vicinity : '')
                                        setFieldValue('locationGooglePlaceId', place && place.place_id ? place.place_id : '')
                                        setFieldValue('locationGooglePlaceUrl', place && place.url ? place.url : '')
                                        setFieldValue('locationAddressFormatted', place && place.formatted_address ? place.formatted_address : '')
                                        setFieldValue('locationAddressComponents', place && place.address_components ? JSON.stringify(place.address_components) : '')
                                        handleClose()
                                    }}
                                    onCloseRequest={handleClose}
                                />
                            ),
                            document.getElementById('maps-place-select-container')
                        )
                    }
                </div>
            )}
        </EventFormModule>
    )
}

export default flowRight(
    withTranslationCustom('events'),
    withRouter,
)(EventFormLocationModule)
